import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {FormulaPayableScheme} from './formula-payable-scheme.model';
import * as FormulaPayableSchemeActions from './formula-payable-scheme.actions';

export const formulaPayableSchemesFeatureKey = 'formulaPayableSchemes';

export interface State extends EntityState<FormulaPayableScheme> {
  // additional entities state properties
}

export const adapter: EntityAdapter<FormulaPayableScheme> = createEntityAdapter<FormulaPayableScheme>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(FormulaPayableSchemeActions.addFormulaPayableScheme,
    (state, action) => adapter.addOne(action.formulaPayableScheme, state)
  ),
  on(FormulaPayableSchemeActions.upsertFormulaPayableScheme,
    (state, action) => adapter.upsertOne(action.formulaPayableScheme, state)
  ),
  on(FormulaPayableSchemeActions.addFormulaPayableSchemes,
    (state, action) => adapter.addMany(action.formulaPayableSchemes, state)
  ),
  on(FormulaPayableSchemeActions.upsertFormulaPayableSchemes,
    (state, action) => adapter.upsertMany(action.formulaPayableSchemes, state)
  ),
  on(FormulaPayableSchemeActions.updateFormulaPayableScheme,
    (state, action) => adapter.updateOne(action.formulaPayableScheme, state)
  ),
  on(FormulaPayableSchemeActions.updateFormulaPayableSchemes,
    (state, action) => adapter.updateMany(action.formulaPayableSchemes, state)
  ),
  on(FormulaPayableSchemeActions.deleteFormulaPayableScheme,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(FormulaPayableSchemeActions.deleteFormulaPayableSchemes,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(FormulaPayableSchemeActions.loadFormulaPayableSchemes,
    (state, action) => adapter.setAll(action.formulaPayableSchemes, state)
  ),
  on(FormulaPayableSchemeActions.clearFormulaPayableSchemes,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
